import { bootstrapDemoShell, makeCollapsible } from '@learnforge/demo-kit';
import '@learnforge/demo-kit/styles.css';
import '@learnforge/demo-kit/shell.css';
import './styles.css';

import { i18n } from './i18n';
import { EXPERIMENTS } from './experiments';
import type { ExperimentKey, StatsContext } from './types';

const ORDER: readonly ExperimentKey[] = [
  'survey-explorer',
  'distribution-sculptor',
  'two-variable-lab',
  'sampling-lab',
  'probability-diagrams',
];

// ?shot=<id> preset ids are 1:1 with experiment keys (screenshot-presets.ts).
const SHOT_ID_TO_EXP: Record<string, ExperimentKey> = {
  'survey-explorer': 'survey-explorer',
  'distribution-sculptor': 'distribution-sculptor',
  'two-variable-lab': 'two-variable-lab',
  'sampling-lab': 'sampling-lab',
  'probability-diagrams': 'probability-diagrams',
};

bootstrapDemoShell({
  slug: 'statistics',
  i18n,
  experiments: EXPERIMENTS,
  order: ORDER,
  eyebrowKey: 'app.eyebrow',
  shotToExperiment: (id) => SHOT_ID_TO_EXP[id] ?? null,
  extendContext: (base): StatsContext => base,
});

const paramsPanel = document.querySelector<HTMLElement>('.params-panel');
if (paramsPanel) {
  makeCollapsible(paramsPanel, {
    initiallyOpen: true,
    storageKey: 'learnforge:collapsible:statistics:params',
  });
}
